module.exports = __webpack_public_path__ + "img/yacht-5.b48be75d.jpg";